import { defineComponent as n, createBlock as r, openBlock as s, unref as c, mergeProps as m, withCtx as a, createElementVNode as l } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconEyes",
  __name: "IconEyes",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (C, e) => (s(), r(c(p), m(t, { "view-box": "0 0 24 24" }), {
      default: a(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M4.354 6.715C5.028 5.368 6.096 4.25 7.5 4.25s2.472 1.118 3.146 2.465C11.34 8.106 11.75 9.975 11.75 12c0 2.024-.409 3.894-1.104 5.285C9.972 18.632 8.904 19.75 7.5 19.75s-2.472-1.118-3.146-2.465C3.66 15.894 3.25 14.025 3.25 12c0-2.024.409-3.894 1.104-5.285m.82 2.046C5.558 8.279 6.013 8 6.5 8 7.88 8 9 10.239 9 13c0 2.594-.987 4.726-2.252 4.976.266.19.523.274.752.274.53 0 1.21-.449 1.804-1.636.571-1.142.946-2.772.946-4.614S9.875 8.528 9.304 7.386C8.711 6.199 8.03 5.75 7.5 5.75S6.29 6.199 5.696 7.386A7.898 7.898 0 0 0 5.174 8.76m1.342 2.25a.5.5 0 0 0-1-.024 9.923 9.923 0 0 0 .185 2.11.5.5 0 1 0 .982-.19 8.924 8.924 0 0 1-.167-1.896m6.838-4.295C14.028 5.368 15.096 4.25 16.5 4.25s2.473 1.118 3.146 2.465C20.34 8.106 20.75 9.975 20.75 12c0 2.024-.409 3.894-1.104 5.285-.674 1.347-1.742 2.465-3.146 2.465s-2.472-1.118-3.146-2.465C12.66 15.894 12.25 14.025 12.25 12c0-2.024.409-3.894 1.104-5.285m.82 2.046C14.558 8.279 15.013 8 15.5 8c1.38 0 2.5 2.239 2.5 5 0 2.594-.988 4.726-2.251 4.976.265.19.522.274.751.274.53 0 1.21-.449 1.804-1.636.571-1.142.946-2.772.946-4.614s-.375-3.472-.946-4.614C17.711 6.199 17.03 5.75 16.5 5.75s-1.21.449-1.804 1.636a7.905 7.905 0 0 0-.522 1.375m1.342 2.25a.5.5 0 1 0-1-.024 9.929 9.929 0 0 0 .185 2.11.5.5 0 0 0 .981-.19 8.93 8.93 0 0 1-.166-1.896",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
